  $(document).ready(function() {
    var productLimit = 12;  // Initial product limit

    $('#load-more-button').on('click', function() {
      var hiddenProducts = $('#collectionsContent .product.hidden');
      var productsToShow = hiddenProducts.slice(0, productLimit);

      productsToShow.removeClass('hidden');

      // Update the product limit for the next click
      productLimit += 12;

      // Check if all products are visible, then hide the button
      if (hiddenProducts.length <= productLimit) {
        $(this).hide();
      }
    });

    // Initially hide products beyond the initial product limit
    $('.product').slice(productLimit).addClass('hidden');
    
    // Check if all products are visible initially, then hide the button
    var allProducts = $('#collectionsContent .product');
    if (allProducts.length <= productLimit) {
      $('#load-more-button').hide();
    }
  });

